export const getOnlyDigitalString = (value: string) => value.replace(/\D/g, '')
